import Keycloak from 'keycloak-js';

const keycloakDomain = process.env.REACT_APP_DOMAIN
    ? `auth.${process.env.REACT_APP_DOMAIN}`
    : 'auth.dev.arvis.com.tr';

// Default KC instance for agents (/login path)
const keycloak = new Keycloak({
    url: `https://${keycloakDomain}`,
    realm: 'arvis',
    clientId: process.env.REACT_APP_KC_CLIENT_ID || 'ops-dashboard'
});

// Separate KC instance for admins (/admin-login path)
export const keycloakAdmin = new Keycloak({
    url: `https://${keycloakDomain}`,
    realm: 'arvis',
    clientId: process.env.REACT_APP_KC_ADMIN_CLIENT_ID || 'ops-dashboard-admin'
});

/**
 * Returns the current active KC token from whichever instance is authenticated.
 * Safe to call even when KC is not in use (returns null).
 */
export function getKcToken() {
    if (keycloak.authenticated) return keycloak.token || null;
    if (keycloakAdmin.authenticated) return keycloakAdmin.token || null;
    return null;
}

/**
 * Calls updateToken(minValidity) on whichever KC instance is active.
 * Used by the axios interceptor to silently refresh before each request.
 */
export async function ensureKcToken(minValidity = 30) {
    const activeKc = keycloak.authenticated ? keycloak
        : keycloakAdmin.authenticated ? keycloakAdmin
        : null;
    if (!activeKc) return null;
    try {
        await activeKc.updateToken(minValidity);
    } catch {
        activeKc.login();
        return null;
    }
    return activeKc.token || null;
}

export default keycloak;
